<template>
  <Card variant="outline" size="medium">
    <template #header>
      <Text variant="h4">Pets</Text>

      <slot name="actions" />
    </template>

    <View v-if="personalDetails?.hasPets && (pets || petDetails)" gap="sm" direction="column">
      <Text variant="body-medium" v-if="pets">{{ pets }}</Text>
      <Text variant="body-medium">{{ petDetails }}</Text>
      <FileGallery v-if="petPhotos?.length" :files="petPhotos" size="xs" />
    </View>

    <Text v-else variant="body-medium">No pets</Text>
  </Card>
</template>

<script setup lang="ts">
import pluralize from 'pluralize';
import { computed } from 'vue';

import { Card, Text, View } from '@tallo/design-system';
import { FileDto, FileGallery } from '@tallo/file-manager';

import { ApplicationRenterDetailsDto } from '../../interfaces/renter-details.interface';

const props = defineProps<{ personalDetails?: ApplicationRenterDetailsDto | null; petPhotos?: FileDto[] | null }>();

const petDetails = computed(() => props.personalDetails?.petDetails);
const pets = computed(() => {
  if (!props.personalDetails) {
    return null;
  }

  const result: string[] = [];
  const petsData = [
    {
      title: 'Large dog',
      count: props.personalDetails.numberOfLargeDogs,
    },
    {
      title: 'Medium dog',
      count: props.personalDetails.numberOfMediumDogs,
    },
    {
      title: 'Small dog',
      count: props.personalDetails.numberOfSmallDogs,
    },
    {
      title: 'Cat',
      count: props.personalDetails.numberOfCats,
    },
    {
      title: 'Other pet',
      count: props.personalDetails.numberOfOtherPets,
    },
  ];

  petsData.forEach(({ title, count }) => {
    if (count) {
      result.push(pluralize(title, count, true));
    }
  });

  return result.join(', ');
});
</script>
